import React from "react";
import { AppStore } from '../../AppStore';
import { BarLoader } from 'react-spinners';

type LoadingWrapperProps = {
  children: React.ReactNode;
};

const LoadingWrapper = ({ children }: LoadingWrapperProps) => {
  const { loadingContent, loadingContentError, loadingUser } = AppStore.useState();

  if (loadingContentError) {
    return (
      <>
        <div>error loading puzzles</div>
      </>
    )
  }

  if (!loadingContent && !loadingUser) {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <>
      <div className="loadingScreen">
        <BarLoader/>
      </div>
    </>
  );
};

export default LoadingWrapper;
